import { AnimatedArc, BlankNavbar, LoadingContent, SpinnerContainer, WorkSpaceLoadingWrapper } from './styles';
import SVGIcon from '../../../assets/images/svg/SVGIcon';
import { rootStore } from '../../../mobx/rootStore';
import { observer } from 'mobx-react-lite';

const WorkSpaceLoading = () => {
  const { appStore } = rootStore;
  const { themeMode, isNavbarShow } = appStore || {};
  return (
    <>
      <BlankNavbar className={`navbar`} />
      <WorkSpaceLoadingWrapper className={`right-content ${!isNavbarShow ? 'navbar-hidden' : ''}`}>
        <LoadingContent>
          <SpinnerContainer>
            <AnimatedArc className={themeMode?.theme === 'dark' ? 'dark-border' : ''} />
            <SVGIcon name='workspace-loading-logo' width='36' height='36' viewBox='0 0 36 36' />
          </SpinnerContainer>
          <p>Setting up your workspace...</p>
        </LoadingContent>
      </WorkSpaceLoadingWrapper>
    </>
  );
};

export default observer(WorkSpaceLoading);
